import styled from "styled-components";

// 모달창의 title
const ModalTitle = styled.h2`
    margin-bottom: 1rem;
`

export default ModalTitle